export enum EmailTemplateType {
    Verification = 'verification',
    MagicSession = 'magicSession',
    Recovery = 'recovery',
    Invitation = 'invitation',
    MfaChallenge = 'mfaChallenge',
    SessionAlert = 'sessionAlert',
    OtpSession = 'otpSession',
}